import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { Box, Chip, IconButton } from '@mui/material';
import Grid from "@mui/material/Grid2"
import { AXIOS_API_INSTANCE, SERVICE_ORDER_SERVICE_COLOR_MAP, SERVICE_ORDER_SERVICE_FRIENDLY_NAMES } from '../../../Constants';
import { send_authorized_request } from '../../../Constants/cognito';
import { useSnackbar } from 'notistack';
import { LoadingBackdropIndeterminate } from '../../LoadingBackdrop';


export default function PendingServicesModal({
    open,
    serviceOrder,
    setServiceOrder,
    setMadeUpdate,
    callback,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [pendingServices, setPendingServices] = React.useState([])
    const [saving, setSaving] = React.useState(false)
    const remaining_pending_services = serviceOrder.service_order_services.filter((service) => service.status === 'PENDING').length

    const changeAll = () => {
        setSaving(true)
        // Loop over the pending services and mark them as in progress by sending an API request for each one
        send_authorized_request(async () => {
            for (const service of serviceOrder.service_order_services.filter((service) => service.status === 'PENDING')) {
                const new_status = {
                    serviceorderservice_id: service.id,
                    status: 'IN_PROGRESS'
                }
                await AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrder.id}/change_service_status`, new_status).then((serviceOrder) => {
                    enqueueSnackbar('Successfully changed status', { variant: 'success' })
                    setServiceOrder(serviceOrder.data.data)
                    setMadeUpdate(true)
                }).catch((error) => {
                    enqueueSnackbar(`Failed to change status <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            }
            setSaving(false)
        })
    }

    const changeStatus = (id) => () => {
        setSaving(true)
        const new_status = {
            serviceorderservice_id: id,
            status: 'IN_PROGRESS'
        }
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrder.id}/change_service_status`, new_status).then((serviceOrder) => {
                setSaving(false)
                enqueueSnackbar('Successfully changed status', { variant: 'success' })
                setServiceOrder(serviceOrder.data.data)
                setMadeUpdate(true)
            }).catch((error) => {
                setSaving(false)
                enqueueSnackbar(`Failed to change status <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }

    React.useEffect(() => {
        if (open) {
            const pending_services = []
            serviceOrder.service_order_services.forEach((service) => {
                if (service.status === 'PENDING' && service.customer_approved_status === 'APPROVED') {
                    // Only include services that are approved but not marked in progress
                    pending_services.push(service)
                }
            })
            setPendingServices(pending_services)
        } else {
            setPendingServices([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => callback()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                maxWidth={'sm'}
                fullWidth={true}
            >
                <LoadingBackdropIndeterminate
                    open={saving}
                    text={"Saving Order"}
                />
                <DialogTitle>
                    <span style={{ "paddingRight": "24px" }}>Pending Services</span>
                    <IconButton
                        aria-label="close"
                        onClick={() => callback()}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ pb: 1 }}>
                    <Box sx={{ minWidth: '300px' }}>
                        <h4>There are approved services that are not marked in progress:</h4>
                        {pendingServices.length > 1 &&
                            <Grid container size={12} sx={{ padding: "5px 0" }} alignItems={"center"}>
                                <Grid size={8}>
                                </Grid>
                                <Grid size={4} sx={{ textAlign: "right" }}>
                                    {/* Button to mark service as in progress */}
                                    <Button variant='contained' color={SERVICE_ORDER_SERVICE_COLOR_MAP["IN_PROGRESS"]} disabled={remaining_pending_services < 1} onClick={changeAll}>Mark All In Progress</Button>
                                </Grid>
                            </Grid>
                        }
                        <Grid container>
                            {pendingServices.map((s) => {
                                const service = serviceOrder.service_order_services.find((x) => x.id === s.id)
                                if (!service) return null; // Skip if service not found
                                return (
                                    <Grid container size={12} key={service.id} sx={{ padding: "5px 0" }} alignItems={"center"}>
                                        <Grid size={5}>
                                            <span>{service.name}</span>
                                        </Grid>
                                        <Grid size={3}>
                                            <Chip key={`${service.status}-${service.id}`} label={SERVICE_ORDER_SERVICE_FRIENDLY_NAMES[service.status]} color={SERVICE_ORDER_SERVICE_COLOR_MAP[service.status] || 'primary'} />
                                        </Grid>
                                        <Grid size={4} sx={{ textAlign: "right" }}>
                                            {/* Button to mark service as in progress */}
                                            {service.status === 'PENDING' &&
                                                <Button variant='contained' color={SERVICE_ORDER_SERVICE_COLOR_MAP["IN_PROGRESS"]} onClick={changeStatus(service.id)}>Mark In Progress</Button>
                                            }
                                        </Grid>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 10px 10px 10px" }} spacing={2}>
                        <Grid size="auto">
                            {/* <Button variant='outlined' color='error' onClick={() => callback(true)}>
                                <CancelIcon /> <Box sx={{ pl: 1 }}><span>Cancel</span></Box>
                            </Button> */}
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" onClick={() => callback()}>
                                <CheckIcon /> <Box sx={{ pl: 1 }}><span>Ok</span></Box>
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div >)
    );
}